import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import { useContentFilter } from '../../../utils/hooks/useContentFilter';
import { SubscriptionPurchaseFTUEContext } from '../../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import { useIsCurrentUserDeviationAuthor } from '../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { LoggedOutReturnType } from '../../../redux/loggedout';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import { formatDollars } from '../../../utils/formatting';
import { getDeviationPremiumDownload } from './permissions';
import s from './PremiumDownloadButton.scss';
const logger = ddt.createLogger('downloadbutton');
const PremiumDownloadButton = ({ deviation , className , onDownload  })=>{
    var _deviation_pcp, _deviation_pcp1;
    // note: mouseEnter and mouseExit aren't used since this button isn't an icon button,
    // doesn't need a tooltip itself, and, bc of that, doesn't need to pause the comment tooltip
    const { t  } = useTranslation();
    const { isLoggedIn , sendUserToJoinPage  } = useRestrictToLoggedIn();
    const { contentFilter , pushUserSettingsModal  } = useContentFilter();
    // when the user first purchases a subscription, open the tooltip and highlight the icon
    const isButtonHighlighted = useContext(SubscriptionPurchaseFTUEContext) === 'tooltips';
    logger.log('PremiumDownloadButton, deviation:', deviation);
    const isOwner = useIsCurrentUserDeviationAuthor(deviation);
    const { download , permission  } = getDeviationPremiumDownload(deviation, isOwner);
    logger.log({
        isOwner,
        download,
        permission
    });
    if (!download) {
        logger.log('has no downloads');
        return null;
    }
    const wrapperProps = {
        className: className,
        popoverWrapperClassName: s['wrapper']
    };
    let buttonProps = {
        biData: PureBiData({
            evid: 350,
            ispaiddownload: 1,
            deviationid: deviation.deviationId
        }),
        variant: isButtonHighlighted ? 'highlighted' : 'solid',
        size: 'medium',
        rounded: true,
        className: s['button']
    };
    let buttonLabel = t('actionbar.download');
    const isPurchasable = permission === 'purchasable';
    if (isPurchasable) {
        const dollars = download.downloadDollarPrice;
        const cents = dollars - (0 | dollars);
        const price = formatDollars(download.downloadDollarPrice, {
            minimumFractionDigits: cents ? 2 : 0
        });
        buttonLabel = price ? t('actionbar.downloadFor', {
            price
        }) : t('actionbar.download.mustPurchase');
    }
    const checkoutUrl = ((_deviation_pcp = deviation.pcp) === null || _deviation_pcp === void 0 ? void 0 : _deviation_pcp.subproductId) ? Url.checkoutLink((_deviation_pcp1 = deviation.pcp) === null || _deviation_pcp1 === void 0 ? void 0 : _deviation_pcp1.subproductId) : undefined;
    // send anon to sisu
    if (!isLoggedIn) {
        return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, _extends({}, wrapperProps, {
            tooltip: t('actionbar.download.mustLogIn')
        }), /*#__PURE__*/ React.createElement(BuyButton, _extends({}, buttonProps, {
            onClick: ()=>sendUserToJoinPage(ReferralType.ANON_DOWNLOAD, checkoutUrl, LoggedOutReturnType.JOIN_ONLY)
        }), buttonLabel));
    }
    // still needs to purchase at checkout
    if (isPurchasable && !!checkoutUrl) {
        // we may need them to update their mature content settings before
        // sending them to checkout or ponies will 404 the page
        const needsBrowsingModeChange = deviation.isMature && contentFilter !== 'mature';
        buttonProps = needsBrowsingModeChange ? _object_spread_props(_object_spread({}, buttonProps), {
            onClick: ()=>pushUserSettingsModal()
        }) : _object_spread_props(_object_spread({}, buttonProps), {
            href: checkoutUrl
        });
    // is it already purchased?
    } else if (permission === 'downloadable') {
        buttonProps = _object_spread_props(_object_spread({}, buttonProps), {
            href: download.url,
            target: '_blank',
            download: true,
            onClick: onDownload
        });
    }
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, _extends({}, wrapperProps, {
        allowMobilePopover: isPurchasable
    }), /*#__PURE__*/ React.createElement(BuyButton, _extends({}, buttonProps), buttonLabel));
};
PremiumDownloadButton.displayName = 'PremiumDownloadButton';
export default PremiumDownloadButton;
